import RepositoryFactory from "@/marcom/Apicall/RepositoryFactory";
const campaign = RepositoryFactory.campaign;

export default {
  getAll({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await campaign.getAll(payload);
        // commit("GET_EMAIL_CONFIG", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
};
